// EmailJS settings shared by the Booking and Contact forms.
// Both forms send to you with one template; the form_type field says which form sent it.
export const EMAILJS_SERVICE_ID = 'service_wbx28fk';
export const EMAILJS_TEMPLATE_ID = 'template_slqtjgw';
export const EMAILJS_PUBLIC_KEY = 'gylrO-VfBTkQ2ZM4z';

// Second template: the copy emailed to the customer after they book.
// Paste its Template ID from your EmailJS dashboard. Leave as is to turn customer emails off.
export const EMAILJS_CUSTOMER_TEMPLATE_ID = 'template_2t0h1ph';

// Email service the customer copy is sent from (bookingabsolutemobility@gmail.com).
// Paste its Service ID from EmailJS > Email Services. Until then, the main service is used.
export const EMAILJS_CUSTOMER_SERVICE_ID = 'service_2btdgts';
